import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Priya Sharma',
    role: 'Regular Student',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
    text: 'Joining Shree Yoga Fitness has been life-changing. The personalized attention and peaceful environment make every session something to look forward to. My back pain has completely disappeared after 3 months of regular practice.'
  }, {
    name: 'Rahul Deshmukh',
    role: 'Corporate Professional',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=200',
    text: "As someone with a stressful IT job, the evening batches are my sanctuary. The instructor's deep knowledge of pranayama has helped me manage my stress levels significantly. Highly recommend!"
  }, {
    name: 'Anjali Patil',
    role: 'Mother of two',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1bfa8ea?auto=format&fit=crop&q=80&w=200',
    text: 'I started with the prenatal yoga classes and continued with the regular batches post-pregnancy. The community here is so supportive and the studio hygiene is impeccable. Best yoga studio in Lohegaon!'
  }, {
    name: 'Vikram Singh',
    role: 'Fitness Enthusiast',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
    text: 'The Power Yoga sessions are intense and exactly what I needed to build core strength. The instructor pays close attention to alignment which prevents injuries. Outstanding experience.'
  }, {
    name: 'Sneha Joshi',
    role: 'Beginner',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
    text: "I was very intimidated to start yoga, but the welcoming atmosphere here put me at ease immediately. They really mean it when they say 'all levels welcome'. I've seen great progress in my flexibility."
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % testimonials.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);
  const nextSlide = () => {
    setIsAutoPlaying(false);
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prevSlide = () => {
    setIsAutoPlaying(false);
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section id="testimonials" className="py-24 bg-white overflow-hidden relative" data-id="element-335">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1/2 bg-yoga-lightest/50 -skew-y-3 transform origin-top-left -z-10" data-id="element-336"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-337">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-338">
          <FadeIn data-id="element-339">
            <div className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-4 py-1.5 mb-6 shadow-sm" data-id="element-340">
              <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="Google" className="w-4 h-4" data-id="element-341" />
              <div className="flex text-yellow-400" data-id="element-342">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-343" />)}
              </div>
              <span className="text-yoga-dark text-sm font-bold" data-id="element-344">
                4.9 Rating
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-yoga-dark mb-6" data-id="element-345">
              Stories from our community
            </h2>
            <p className="text-lg text-yoga-muted" data-id="element-346">
              Don't just take our word for it. Hear what our students have to
              say about their journey with Shree Yoga Fitness.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={200} data-id="element-347">
          <div className="relative max-w-4xl mx-auto" data-id="element-348">
            {/* Carousel Container */}
            <div className="overflow-hidden relative rounded-3xl bg-yoga-warm p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-349">
              <Quote className="absolute top-8 left-8 w-16 h-16 text-yoga-primary/10 rotate-180" data-id="element-350" />

              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentIndex * 100}%)`
            }} data-id="element-351">
                {testimonials.map((testimonial, idx) => <div key={idx} className="w-full flex-shrink-0 px-4" data-id="element-352">
                    <div className="flex flex-col items-center text-center" data-id="element-353">
                      <div className="flex text-yoga-primary mb-6" data-id="element-354">
                        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-355" />)}
                      </div>
                      <p className="text-xl md:text-2xl text-yoga-dark font-serif italic mb-10 leading-relaxed" data-id="element-356">
                        "{testimonial.text}"
                      </p>
                      <div className="flex items-center gap-4" data-id="element-357">
                        <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-yoga-primary" data-id="element-358" />
                        <div className="text-left" data-id="element-359">
                          <h4 className="font-bold text-yoga-dark text-lg" data-id="element-360">
                            {testimonial.name}
                          </h4>
                          <p className="text-yoga-muted text-sm" data-id="element-361">
                            {testimonial.role}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex justify-center items-center gap-6 mt-8" data-id="element-362">
              <button onClick={prevSlide} className="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-yoga-dark hover:bg-yoga-primary hover:text-white hover:border-yoga-primary transition-colors shadow-sm" aria-label="Previous testimonial" data-id="element-363">
                <ChevronLeft className="w-6 h-6" data-id="element-364" />
              </button>

              <div className="flex gap-2" data-id="element-365">
                {testimonials.map((_, idx) => <button key={idx} onClick={() => {
                setIsAutoPlaying(false);
                setCurrentIndex(idx);
              }} className={`w-3 h-3 rounded-full transition-colors ${currentIndex === idx ? 'bg-yoga-primary' : 'bg-gray-300'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-366" />)}
              </div>

              <button onClick={nextSlide} className="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-yoga-dark hover:bg-yoga-primary hover:text-white hover:border-yoga-primary transition-colors shadow-sm" aria-label="Next testimonial" data-id="element-367">
                <ChevronRight className="w-6 h-6" data-id="element-368" />
              </button>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}